import { JottaTermsAndConditions } from './JottaTermsAndConditions'
import { MediamarktTerms } from './MediamarktTerms'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'
import type { FC } from 'react'
import type { Locale } from '@jotta/i18n/locale'
import type { BrandKey } from '@jotta/config/brand'

export function TermsSwitch({
  brand,
  locale,
  Fallback,
}: {
  brand: BrandKey
  locale: Locale
  Fallback?: FC
}) {
  switch (brand) {
    case 'JOTTACLOUD':
      return <JottaTermsAndConditions />
    case 'MEDIAMARKT':
    case 'LETS_GO':
      return <MediamarktTerms locale={locale} />
    case 'ONLIME_WL':
    case 'ELGIGANTEN':
    case 'PHONERO':
    case 'HALEBOP':
    case 'ELKO':
    case 'TELIA_CLOUD':
    case 'GIGANTTI':
    case 'OBOS':
    case 'TEST':
    case 'SATURN':
    case 'ELKJOP':
    case 'GET':
    case 'TDC_NO':
    case 'COMHEM':
      return Fallback ? <Fallback /> : undefined
    default:
      return exhaustiveGuard(brand)
  }
}
